export default __webpack_public_path__ + "static/media/Ed.33e7df8e.png";